import React, { useEffect } from 'react';

const ColorPicker = ({ id, defaultColor, changeColor, inheritStyle }) => {

    useEffect(() => {
        initializeOrUpdateMinicolors();
    }, [defaultColor]);

    const initializeOrUpdateMinicolors = () => {
        const element = window.$(`#${id}`);
        if (element.data('minicolors-initialized')) {
            element.minicolors({value: defaultColor});
        } else {

            element.minicolors({
                control: 'hue',
                letterCase: 'lowercase',
                position: 'bottom left',
                change: onChangeColor,
                theme: 'bootstrap',
                value: defaultColor,
            });
            
        }
    };

    const onChangeColor = (hex, opacity) => {
        if (!hex) return;
        changeColor(hex);
    };

    return (
        <input className="form-control minicolors-input" data-control="hue" type="text" id={id} defaultValue={defaultColor} disabled={inheritStyle}/>
    );
};

export default ColorPicker;
